import { theme } from '../../../theme';

// Brand-aligned colors for Recharts series so charts match the Hanover palette
// (navy primary / green secondary) instead of Recharts' default blue.
export const chartColors = {
  /** Primary data series — the kelly-green brand accent; reads well on the light background. */
  series: theme.palette.secondary.main,
  /** Secondary data series / emphasis — slate navy. */
  seriesAlt: theme.palette.primary.main,
  /** Standard fill opacity for area/radar series. */
  fillOpacity: 0.25,
};
